import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Price, ScriptLoader } from '@spartacus/core';
import { Subject } from 'rxjs';
import { Cart } from '@spartacus/cart/base/root';
import { PayPalBannerConfig } from '../../../models';
import { BaseStoreService } from '../../../services';

@Component({
  selector: 'wc-paypal-banner',
  templateUrl: './paypal-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PaypalBannerComponent implements OnInit, OnDestroy {
  paypalBannerConf: PayPalBannerConfig;
  cart: Cart;
  @Input() price: Price;
  @Input() position: string;
  @Input() messageLanguage: string;

  readonly PAYPAL_URL: string = 'https://www.paypal.com/sdk/js';
  private readonly destroy$: Subject<void> = new Subject();
  readonly textAlign: string = 'center';

  constructor(private baseStoreService: BaseStoreService, private scriptLoader: ScriptLoader) {}

  ngOnInit(): void {
    const baseStore = this.baseStoreService.baseStore;
    this.paypalBannerConf = {
      enabled: baseStore.payPalBannerConfig?.enabled,
      clientID: baseStore.payPalBannerConfig?.clientID
    };
    if (this.paypalBannerConf?.enabled) {
      this.scriptLoader.embedScript({
        src: this.PAYPAL_URL,
        params: {
          'client-id': this.paypalBannerConf.clientID,
          currency: this.price?.currencyIso,
          components: 'messages'
        },
        attributes: {
          'data-namespace': 'PayPalBannerSDK'
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get activeLanguage(): string {
    return this.messageLanguage && this.messageLanguage.split('_')[0]?.toUpperCase();
  }
}
